export default "__VITE_ASSET__DZIq2uwz__"